export default "__VITE_ASSET__DDiAukdL__"